import Vue from 'vue';
import '@/public/ares-register';
import '@/public/index';
import index from './index.vue';
import Toast from 'vue2-toast';
// import '@/utils/performance';
import NbImage from '@tencent/nb-h5-image';
// import DSL from '@tencent/vue-dsl-framework';

async function entry() {
  // 本地调试需要额外去拉取组件js文件
  // 1、拉取manifest2、拼接组件js script
  if (process.env.BUILD_ENV === 'dev' || process.env.isDebug) {
    const loadCompScript = require('@shared/loadCompScript').default;
    const { GetSearch } = require('@/utils/html_util');
    const PageID = GetSearch('PageID');
    await loadCompScript({
      pageId: PageID,
    });
  }
  Vue.use(Toast);
  Vue.use(NbImage);
  // Vue.use(DSL);

  Vue.prototype.pxToRem = function (value) {
    return `${value / 28}rem`;
  };

  try {
    new Vue({ // eslint-disable-line no-new
      el: '#app',
      render: h => h(index),
    });
  // report.monitor(MONITORS.suc);
  } catch (err) {
    console.error(err);
  // report.monitor(MONITORS.fail);
  }
}
entry();
